import Vue from 'vue';
import SeoControl from "./components/SeoControl.vue";

setTimeout(()=>{
    new Vue({
        render: h => h(SeoControl),
    }).$mount('#meta');
}, 1000);

